import './App.css';
import { useAuth } from './AuthContext';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function NavBar() {
  const { isLoggedIn, user, logout } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  // Add a toggle function
const toggleDropdown = (e) => {
  e.stopPropagation(); // Prevents clicks from bubbling up
  setIsDropdownOpen(!isDropdownOpen);
};
useEffect(() => {
  const closeMenu = () => setIsDropdownOpen(false);
  window.addEventListener('click', closeMenu);
  return () => window.removeEventListener('click', closeMenu);
}, []);
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleSpaces = () => {
    if (user && user.name) {
      navigate(`/${user.name}/spaces`);
    }
  };

  const handleMyPage = () => {
    if (user && user.name) {
      navigate(`/main/${user.name}`);
    }
  };

  const handleDashboard = () => {
    if (user && user.name) {
      navigate(`/dashboard/${user.name}`);
    }
  };

  // --- Style Constants for "Rustic & Elegant" look ---
  const rusticGreen = "#00c853";
  const deepBlack = "#0a0a0a";

  return (
    <nav className="navbar-neon" style={{ background: deepBlack, borderBottom: `3px solid ${deepBlack}`, boxShadow: 'none' }}>
      <div className="nav-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px' }}>
        
 <div className="nav-brand-rustic" style={{ 
  background: "#00c853", 
  border: "2px solid #0a0a0a", // Thinner border for subtlety
  padding: "4px 20px", 
  display: "flex", 
  alignItems: "center",
  justifyContent: "center",
  height: "48px",
  boxShadow: "none" 
}}>
  <a href="/" style={{ 
    fontFamily: "'Outfit', sans-serif", // Change to 'Syne' or 'Outfit'
    fontSize: "28px", 
    fontWeight: "700", // Not too thick
    color: "#0a0a0a", 
    textDecoration: "none",
    letterSpacing: "0.5px", // More breathable
    textTransform: "none" // Removed all-caps for a softer look
  }}>
    FocusWin
  </a>
</div>
        <ul className="nav-menu" style={{ display: 'flex', alignItems: 'center', listStyle: 'none', gap: '10px' }}>
          <li className="nav-item"><a href="/home" className="nav-link-rustic" style={linkStyle}>Home</a></li>
          <li className="nav-item"><a href="/features" className="nav-link-rustic" style={linkStyle}>Features</a></li>
          <li className="nav-item"><a href="/contact" className="nav-link-rustic" style={linkStyle}>Contact</a></li>

          {!isLoggedIn ? (
            <li className="nav-item"><a href="/login" className="nav-link-rustic" style={linkStyle}>Login</a></li>
          ) : (
            <>
              <li className="nav-item">
                {/* My Page Button */}
<button onClick={handleMyPage} style={{
  background: "#00c853",
  color: "#0a0a0a",
  border: "2px solid #0a0a0a",
  padding: "8px 18px",
  fontFamily: "'Space Grotesk', sans-serif",
  fontWeight: "800",
  fontSize: "14px",
  cursor: "pointer",
  transition: "none",
  boxShadow: "none"
}}>
  My Page
</button>
              </li>
              <li className="nav-item">
                <button onClick={handleSpaces} style={{ ...buttonStyle, background: '#D90429', color: 'white' }}>🌐 Spaces</button>
              </li>
              <li className="nav-item">
                {/* Dashboard Button */}
<button onClick={handleDashboard} style={{
  background: "#00c853",
  color: "#0a0a0a",
  border: "2px solid #0a0a0a",
  padding: "8px 18px",
  fontFamily: "'Space Grotesk', sans-serif",
  fontWeight: "800",
  fontSize: "14px",
  cursor: "pointer",
  transition: "none",
  boxShadow: "none"
}}>
  Dashboard
</button>
              </li>
             <li className="nav-item profile-dropdown" style={{ position: 'relative', marginLeft: '10px' }}>
  <div 
    className="profile-circle-rustic" 
    onClick={toggleDropdown} // 🌟 Change: Controlled by click
    style={{
      width: '40px',
      height: '40px',
      borderRadius: '0', 
      background: rusticGreen,
      border: `2px solid ${deepBlack}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      color: deepBlack,
      cursor: 'pointer' // 🌟 Added pointer
    }}
  >
    {user?.name?.charAt(0).toUpperCase()}
  </div>

  {/* 🌟 Conditional Rendering based on state */}
  {isDropdownOpen && (
    <div className="dropdown-content-rustic" style={{
      position: 'absolute',
      top: '50px', // Adjusted to be right below the circle
      right: '0',
      background: '#00c853',
      border: `2px solid ${deepBlack}`,
      padding: '10px',
      zIndex: 1000,
      minWidth: '120px',
      boxShadow: 'none' // Staying with your rustic theme
    }}>
      <button 
        onClick={handleLogout} 
        style={{
          background: 'none',
          border: 'none',
          color: deepBlack,
          fontFamily: "'Space Grotesk', sans-serif",
          fontWeight: '700',
          cursor: 'pointer',
          width: '100%',
          textAlign: 'left'
        }}
      >
        Logout
      </button>
    </div>
  )}
</li>
            </>
          )}
        </ul>

        {!isLoggedIn && (
          <button 
            style={{ 
              background: rusticGreen, 
              color: deepBlack, 
              border: `2px solid ${deepBlack}`, 
              padding: '10px 20px', 
              fontWeight: '900', 
              cursor: 'pointer',
              fontFamily: "'Space Grotesk', sans-serif"
            }} 
            onClick={() => navigate('/signup')}
          >
            GET STARTED
          </button>
        )}
      </div>
    </nav>
  );
}

// Reusable Inline Styles for links and buttons to remove "AI Glow"
const linkStyle = {
  fontFamily: "'Space Grotesk', sans-serif",
  fontSize: '16px',
  fontWeight: '600',
  color: 'white',
  textDecoration: 'none',
  padding: '8px 12px',
  transition: 'none', // Removed glow transition
  border: '1px solid transparent'
};

const buttonStyle = {
  background: 'transparent',
  border: '2px solid #00c853',
  color: '#00c853',
  padding: '6px 15px',
  fontFamily: "'Space Grotesk', sans-serif",
  fontWeight: '700',
  cursor: 'pointer',
  transition: 'all 0.2s ease'
};

export default NavBar;
